/**
 * Substituto do modulo interno do Gatsby `.cache/strip-prefix.js`, injetado
 * pelo webpack via createStripPrefixReplacementPlugin (ver index.js).
 *
 * Motivo: o original so remove o pathPrefix quando a string e o prefixo exato
 * ou continua com "/". Nas LPs Salinas (pathPrefix + trailingSlash "never"),
 * uma URL com query string ("/prefix?utm_source=x") nao casa com nenhum dos
 * dois casos, o prefixo nao e removido e o loader busca o page-data num
 * caminho com o prefixo duplicado — o servidor responde erro e o React nunca
 * hidrata (a LP fica so com o HTML estatico, sem os dados do Strapi).
 *
 * Este substituto preserva o comportamento original e acrescenta os casos em
 * que o prefixo e seguido de "?" (query) ou "#" (hash), devolvendo o caminho
 * raiz com o sufixo intacto — exatamente o que o Gatsby devolveria se a URL
 * tivesse a barra final.
 */
export default function stripPrefix(str, prefix = ``) {
  if (!prefix) {
    return str;
  }

  if (str === prefix) {
    return `/`;
  }

  if (str.startsWith(`${prefix}/`)) {
    return str.slice(prefix.length);
  }

  if (str.startsWith(`${prefix}?`) || str.startsWith(`${prefix}#`)) {
    return `/${str.slice(prefix.length)}`;
  }

  return str;
}
